import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const SchedulingModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="4"
            y="4"
            width="16"
            height="16"
            rx="2"
            fill="url(#paint0_linear_123_14396)"
          />
          <path
            d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V9H4V6Z"
            fill="#A680FF"
          />
          <rect x="6.5" y="15" width="2" height="2" rx="0.5" fill="#530047" />
          <rect x="11" y="11" width="2" height="2" rx="0.5" fill="#530047" />
          <rect x="11" y="15" width="2" height="2" rx="0.5" fill="#530047" />
          <rect x="15.5" y="11" width="2" height="2" rx="0.5" fill="#530047" />
          <rect x="15.5" y="15" width="2" height="2" rx="0.5" fill="#530047" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 4.5C7.72386 4.5 7.5 4.72386 7.5 5C7.5 5.27614 7.72386 5.5 8 5.5C8.27614 5.5 8.5 5.72386 8.5 6C8.5 6.27614 8.27614 6.5 8 6.5C7.17157 6.5 6.5 5.82843 6.5 5C6.5 4.17157 7.17157 3.5 8 3.5C8.27614 3.5 8.5 3.72386 8.5 4C8.5 4.27614 8.27614 4.5 8 4.5Z"
            fill="#530047"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 4.5C10.7239 4.5 10.5 4.72386 10.5 5C10.5 5.27614 10.7239 5.5 11 5.5C11.2761 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.2761 6.5 11 6.5C10.1716 6.5 9.5 5.82843 9.5 5C9.5 4.17157 10.1716 3.5 11 3.5C11.2761 3.5 11.5 3.72386 11.5 4C11.5 4.27614 11.2761 4.5 11 4.5Z"
            fill="#530047"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 4.5C13.7239 4.5 13.5 4.72386 13.5 5C13.5 5.27614 13.7239 5.5 14 5.5C14.2761 5.5 14.5 5.72386 14.5 6C14.5 6.27614 14.2761 6.5 14 6.5C13.1716 6.5 12.5 5.82843 12.5 5C12.5 4.17157 13.1716 3.5 14 3.5C14.2761 3.5 14.5 3.72386 14.5 4C14.5 4.27614 14.2761 4.5 14 4.5Z"
            fill="#530047"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17 4.5C16.7239 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.7239 5.5 17 5.5C17.2761 5.5 17.5 5.72386 17.5 6C17.5 6.27614 17.2761 6.5 17 6.5C16.1716 6.5 15.5 5.82843 15.5 5C15.5 4.17157 16.1716 3.5 17 3.5C17.2761 3.5 17.5 3.72386 17.5 4C17.5 4.27614 17.2761 4.5 17 4.5Z"
            fill="#530047"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14396"
              x1="9"
              y1="20"
              x2="9"
              y2="9"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#C4AAFF" />
              <stop offset="1" stop-color="#4FFF8C" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default SchedulingModule;
